import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { tabletMax } from '@css/constants';

export const SocialShareButtonsContainer = styled('div')(css`
  display: flex;
  justify-content: center;
`);

export const leftStyle = css`
  @media(max-width: ${tabletMax}) {
    justify-content: start;
  }
`;

export const SocialShareButton = styled('a')(css`
  padding-right: 24px;
`);

export const SocialShareButtonCopy = styled('button')(css`
  border: 0;
  padding: 0 24px 0 0;
  cursor: pointer;
  background: none;
`);

export const ShareImage = styled('img')(css``);
